"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var mobx_react_1 = require("mobx-react");
var App_1 = require("../../App");
var paginatorList_1 = require("./paginatorList");
var editablelist_1 = require("./editablelist");
var utils_1 = require("../../utils");
var urls_1 = require("../../urls");
var contexts_1 = require("../../interfaces/contexts");
var columns_1 = require("./columns");
var referenceDialog_1 = require("../references/referenceDialog");
var discardRecurrenceDialog_1 = require("../controls/discardRecurrenceDialog");
var ControlTable = (function (_super) {
    __extends(ControlTable, _super);
    function ControlTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClickExportToExcel = function (event) {
            var context = App_1.store.context.get();
            if (context instanceof contexts_1.ProjectContext) {
                var url = (0, urls_1.resolve)(urls_1.Urls.control_excel, context.project) + window.location.search;
                spinnerStart();
                poll_for_result(url, {}, function () {
                    $('div.load_indicator span#finished').html("0");
                    $('div.load_indicator span#max').html("1");
                }, function (data) {
                }, function () {
                    spinnerStop();
                }, function (errorThrown) {
                    notification(errorThrown, { type: "error" });
                    spinnerStop();
                });
            }
            else {
                throw new Error("Cannot export to Excel in this context");
            }
        };
        _this.ControlClickHandler = function (event, control_id) {
            (0, utils_1.preventDefault)(event);
            var location = window.location.search;
            var params = new URLSearchParams(location);
            params.set("control_id", control_id.toString());
            window.history.pushState(null, null, window.location.pathname + "?" + params.toString());
            _this.props.showDetail(control_id);
        };
        _this.refetchTable = function (event) {
            var params = window.location.search;
            if (event) {
                (0, utils_1.preventDefault)(event);
                var url = new URL(event.currentTarget.href);
                var search = new URLSearchParams(url.search);
                params = "?" + search.toString();
            }
            window.history.pushState(null, null, window.location.pathname + params);
            App_1.store.controllist.fetchData(params);
            App_1.store.controllist.filter.fetchData();
        };
        return _this;
    }
    ControlTable.prototype.performBulkUpdate = function (selected, values) {
        values["controls"] = selected;
        return App_1.store.controllist.updateRows(values);
    };
    ControlTable.prototype.performRowUpdate = function (data) {
        var self = this;
        return App_1.store.controllist.updateRows(data).then(function (response) {
            if (response.discard_recurrence) {
                (0, discardRecurrenceDialog_1.discardRecurrenceDialog)({
                    msg: response.discard_recurrence,
                    onDiscardAll: function () {
                        self.performRowUpdate(__assign(__assign({}, data), { remove_recurrence: true, ignore_recurrence_warning: true }))
                            .then(function () { return self.refetchTable(); });
                    },
                    onDiscardOne: function () {
                        self.performRowUpdate(__assign(__assign({}, data), { ignore_recurrence_warning: true }))
                            .then(function () { return self.refetchTable(); });
                    },
                    width: 500,
                });
            }
            else {
                notification(response.message);
            }
        });
    };
    ControlTable.prototype.detachRisk = function (risk, control_id) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2, App_1.store.controllist.checkDetachRisk(risk, control_id).then(function (page) {
                        return App_1.store.controllist.removeRisk(risk, control_id).then(function () {
                            _this.refetchTable();
                            return Promise.resolve(true);
                        });
                    }, function (error) {
                        var reason = JSON.parse(error.responseText);
                        if (reason.confirm) {
                            return optionDialog(reason.confirm, [{
                                    text: gettext("Retain confidentiality"),
                                    "class": "btn btn-primary",
                                    click: function () { return App_1.store.controllist.removeRisk(risk, control_id, true); }
                                }, {
                                    text: gettext("Make public"),
                                    "class": "btn btn-secondary",
                                    click: function () { return App_1.store.controllist.removeRisk(risk, control_id, false); }
                                }], null, null, 500);
                        }
                        else {
                            return Promise.resolve(false);
                        }
                    })];
            });
        });
    };
    ControlTable.prototype.getReferenceDialogFormProps = function () {
        var formProps = App_1.store.referenceDialog.getFormProps();
        var self = this;
        return __assign(__assign({}, formProps), { onSave: function () { return formProps.onSave().then(function () { return self.refetchTable(); }); } });
    };
    ControlTable.prototype.render = function () {
        var data = App_1.store.controllist.data;
        var relationsProps = {};
        relationsProps[columns_1.ControlColumnIds.RISK_RELATIONS] = {
            fetchSearchResults: App_1.store.controllist.fetchAttachableRiskSuggestions,
            fetchRowItems: App_1.store.controllist.fetchRowRiskRelations,
            attach: App_1.store.controllist.attachRisk,
            detach: this.detachRisk.bind(this),
        };
        return (React.createElement("div", { className: "ControlTable" },
            React.createElement(editablelist_1.EditableList, { columns: data.columns, headers: data.headers, rows: data.rows, rowClickHandler: this.ControlClickHandler, performRowUpdate: this.performRowUpdate, refetchTable: this.refetchTable, allowBulkEditing: true, performBulkUpdate: this.performBulkUpdate, bulkEditFields: data.bulk_edit_fields, headerSortClickHandler: this.refetchTable, relationProps: relationsProps, bulkMenuState: App_1.store.controllist.bulkMenu.data, updateBulkMenuState: App_1.store.controllist.bulkMenu.getFetchDataMethod() }),
            React.createElement("div", { className: "ControlTable__Footer mt-1" },
                React.createElement(paginatorList_1.default, { paginator: App_1.store.controllist.data.paginator, click: this.refetchTable })),
            React.createElement(referenceDialog_1.ReferenceDialog, { reference: App_1.store.referenceDialog.reference, isOpen: App_1.store.referenceDialog.isOpen, isReady: App_1.store.referenceDialog.isReady, onDialogClose: App_1.store.referenceDialog.closeDialog.bind(App_1.store.referenceDialog), formProps: this.getReferenceDialogFormProps.bind(this)() })));
    };
    ControlTable = __decorate([
        mobx_react_1.observer
    ], ControlTable);
    return ControlTable;
}(React.Component));
exports.default = ControlTable;
